import http from "@/utils/http";

export default {
  list: (data) => http({ url: '/api/admin/v1/exception/list', data }),
  audit: (data) => http({ url: '/api/admin/v1/exception/audit', data, tip: true }),
}
